    import React, {Fragment, useEffect, useRef, useState} from "react";
    import {Link, NavLink, useLocation,useParams} from "react-router-dom";
    import '../../assets/css/home.css';
    import axios from "axios";
    import clientconfigwebapp, {
        Agent_by_user_get_appbk,
        check_login_appbk, empty_bk,
        FormatNumberByhkh,
        get_first_last_name_local, Get_Weight_txt_bk, modal_select_agent_show_hide,
        scrollTo_uphk, Token_get_appbk
    } from "../../clientconfigwebapp";
    import {toast, ToastContainer} from "react-toastify";
    import Grid from '@mui/material/Grid';

    import Master_Front from "../../pages/Master_Front";
    import LazyLoad from 'react-lazy-load';
    import {Skeleton} from "@mui/material";
    import Modal from "@mui/material/Modal";
    import Grow from "@mui/material/Grow";
    import Box from "@mui/material/Box";
    import Call_Modal_Message from "../../components/Call_Modal_Message/Call_Modal_Message";
    import {Icon_box_1, Icon_call_1, Icon_mail_1, Icon_Sort1, Icon_user_card} from "../../assets/icones/icones";
    import List_data_Show from "./Parts/List_data_Show";
    import Box_Cat_req from "./Parts/Box_Cat_req";

    function useQuery() {
        const { search } = useLocation();

        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    const Requirements = (props) => {
        const location_get_urlbk = useLocation();

        /*  start profile */
        const [wallet_balance, setData_wallet_balance] = useState('0');
        const [first_name_profile,setData_first_name_profile] = useState('');
        const [last_name_profile,setData_last_name_profile] = useState('');
        /*  end profile */


        let query = useQuery();
        const {id_cat_getuser} = useParams();
        const currentSort = query.get('sort');


        const [data_category_box, set_data_category_box] = useState([]);
        const [data_sub_category_box, set_data_sub_category_box] = useState([]);
        const [data_list_posts, set_list_post_Data] = useState([]);






        /* paged start */
        let page_number=query.get("page");
        const page = useRef();
        function paginationStyle (e) {
            const list = page.current.childNodes;
            for (let index = 0; index < list.length; index++) {
                const element = list[index];
                element.className = "";
            }
            e.target.className = "active-page"
        }
        /* paged end */



        useEffect(() => {
            scrollTo_uphk();

            Load_api_page();


        }, [location_get_urlbk]);




        const scrollToSection = (section) => {
            const element = document.getElementById(section);
        };





        const Load_api_page= () => {

            var config = null;

            if(check_login_appbk()==true){
                config = {
                    headers: { Authorization: `Bearer ${Token_get_appbk()}` }
                };
            }

            set_list_post_Data([]);

            var post_get_user="";
            if(!empty_bk(id_cat_getuser)){ post_get_user=String(id_cat_getuser);  }


            /////console.log(post_get_user,"id_cat_getuser")
            ///console.log(page_number,"page_number");
            const data_form = {post_id:String(post_get_user),page_number:page_number,sort_get:String(currentSort)};

            axios.post(`${clientconfigwebapp.siteurl}api/v1/posts-cat-requirements/` ,data_form,config)
                .then((res) => {

                    /////  console.log(res.data)
                    if(String(res.data.data).length > 0) {


                        if(String(res.data.wallet_inventory).length > 0) {  setData_wallet_balance(res.data.wallet_inventory); }
                        if (!empty_bk(res.data.first_name_profile)) { setData_first_name_profile(res.data.first_name_profile); localStorage.setItem('first_name_Get',res.data.first_name_profile);    }
                        if (!empty_bk(res.data.last_name_profile)) { setData_last_name_profile(res.data.last_name_profile); localStorage.setItem('last_name_Get',res.data.last_name_profile);    }


                        if(String(res.data.data_category_box).length > 0) {  set_data_category_box(res.data.data_category_box); }

                        if(String(res.data.subcategories).length > 0) {  set_data_sub_category_box(res.data.subcategories); }

                        if(String(res.data.posts).length > 0) {   set_list_post_Data(res.data.posts); }else{  set_list_post_Data([]);  }





                    }else{
                        if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    }

                }).catch((err) =>{
                /// Setloadinghkfullshow("false");
                toast.error('خطای اتصال به سرور کد 5156', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            });





        }


        return (
            <Fragment>

                <Master_Front wallet_balance={wallet_balance} first_name_profile={first_name_profile}
                              last_name_profile={last_name_profile}>


                    <ToastContainer/>




                <Box_Cat_req data_sub_category_box={data_sub_category_box}  />


                    <div className={"box-border bg-[rgb(255,_255,_255)] rounded-[16px] relative bottom-[46px] w-full p-[27px] flex [flex-flow:row] justify-start items-center"} style={{"border":"1px solid rgb(204, 204, 204)"}} >

    <Icon_Sort1 width={16} height={16} />
                        <span style={{"paddingLeft":"5px"}}> مرتب سازی براساس: </span>
                        <div className={"flex"}>
                            <NavLink
                                reloadDocument={true}
                                to="/requirements/?sort=new"
                                className={({ isActive }) => `text-[12px] !gap-[5px] !pl-[5px] ${isActive && currentSort === 'new' ? 'text-[#01a2d3]' : ''}`}
                            >
                                جدیدترین
                            </NavLink>
                            <NavLink
                                reloadDocument={true}
                                to="/requirements/?sort=old"
                                className={({ isActive }) => `text-[12px] !gap-[5px] !pl-[5px] ${isActive && currentSort === 'old' ? 'text-[#01a2d3]' : ''}`}
                            >
                                قدیمی‌ترین
                            </NavLink>

                        </div>


                    </div>






                 <List_data_Show data_list_posts={data_list_posts}  />







                </Master_Front>

            </Fragment>
        );
    }

    export default Requirements;